export default __webpack_public_path__ + "static/media/Legal.cc67f546.svg";